//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'VideoModel',
  props: {
    showModal: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: function data() {
    return {
      title: "",
      visible: false,
      loading: false,
      url: "",
      screenWidth: document.body.clientWidth,
      screenHeight: 500
    };
  },
  mounted: function mounted() {
    var that = this;

    window.onresize = function () {
      return function () {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      }();
    };
  },
  methods: {
    show: function show(name, url) {
      this.title = name;
      this.loading = true;

      if (!/\.(mp4)$/.test(name)) {
        // 非pdf文件
        window.open(url);
      } else {
        this.visible = true;
        this.url = url;
        this.loading = false;
      }
    },
    hideModal: function hideModal() {
      this.visible = false;
      this.title = "";
      this.url = "";
    }
  }
};